import { MethodsEnum } from "../enums/Methods.ts";
import handleService from "./apiService.ts";

export interface DashboardFiltros {
  medicoId?: string;
  hospitalId?: string;
  convenioId?: string;
  instrumentadorId?: string;
}

export type AgrupamentoTemporal = "DIA" | "MES";

const montarParams = (
  dataInicial?: string,
  dataFinal?: string,
  filtros?: DashboardFiltros,
  agrupamento?: AgrupamentoTemporal
) => {
  const params: Record<string, string> = {};
  if (dataInicial) params.dataInicial = dataInicial;
  if (dataFinal) params.dataFinal = dataFinal;
  if (filtros?.medicoId) params.medicoId = filtros.medicoId;
  if (filtros?.hospitalId) params.hospitalId = filtros.hospitalId;
  if (filtros?.convenioId) params.convenioId = filtros.convenioId;
  if (filtros?.instrumentadorId) params.instrumentadorId = filtros.instrumentadorId;
  if (agrupamento) params.agrupamento = agrupamento;
  return params;
};

const obterDashboardCirurgias = async (
  dataInicial?: string,
  dataFinal?: string,
  filtros?: DashboardFiltros,
  agrupamento?: AgrupamentoTemporal
) => {
  const result = await handleService({
    method: MethodsEnum.GET,
    endpoint: "/dashboard/cirurgias",
    params: montarParams(dataInicial, dataFinal, filtros, agrupamento),
  });
  return result?.data || null;
};

const obterComparacao = async (
  dataInicial?: string,
  dataFinal?: string,
  filtros?: DashboardFiltros,
  agrupamento?: AgrupamentoTemporal
) => {
  const result = await handleService({
    method: MethodsEnum.GET,
    endpoint: "/dashboard/cirurgias/comparacao",
    params: montarParams(dataInicial, dataFinal, filtros, agrupamento),
  });
  return result?.data || null;
};

const dashboardService = { obterDashboardCirurgias, obterComparacao };
export default dashboardService;
